import { render, staticRenderFns } from "./creditedDetailsInfo.vue?vue&type=template&id=1bb8359e&scoped=true"
import script from "./creditedDetailsInfo.vue?vue&type=script&lang=js"
export * from "./creditedDetailsInfo.vue?vue&type=script&lang=js"
import style0 from "./creditedDetailsInfo.vue?vue&type=style&index=0&id=1bb8359e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb8359e",
  null
  
)

export default component.exports